/* eslint-disable no-case-declarations */
/*
 *
 * EasySplitDetails reducer
 *
 */
import produce from 'immer';
import {
  ALL_ACCOUNT_DETAILS,
  ALL_BANK_DETAILS,
  ALL_KYC_BUSINESS_DETAILS,
  ALL_KYC_INDIVIDUAL_DETAILS,
  ALL_SETTLEMENT_DETIALS,
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  RESET_REDUCER_STATES,
  SAVE_KYC_RESPONSE,
  SAVE_SETTLEMENT_CONFIG,
  SAVE_VENDOR_BY_ID,
  SAVE_VENDOR_DETAILS,
  SAVE_VENDOR_DOCS,
  SAVE_VENDOR_KYC_DETAILS,
} from './constants';

export const initialState = {
  isLoading: false,
  vendorDetailsSuccessResponse: false,
  kycDetialsSuccessResponse: false,
  kycDocsSuccessResponse: false,
  SETTLEMENT_DETAILS: {},
  ACCOUNT_DETAILS: {},
  BANK_DETAILS: {},
  KYC_DETAILS: {},
  KYC_DOCUMENTS: {
    pan: [],
    drivingLicense: [],
    uidai: [],
    passport: [],
    voterId: [],
  },
  vendorDocs: {},
  vendorAccountInfo: {},
};

/* eslint-disable default-case, no-param-reassign */
const easySplitDetailsReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, draft => {
    switch (action.type) {
      case RESET_REDUCER_STATES:
        return initialState;

      case ENABLE_LOADER:
        draft.isLoading = true;
        break;

      case DISABLE_LOADER:
        draft.isLoading = false;
        break;

      case SAVE_VENDOR_BY_ID:
        draft.vendorIdData = action.data;
        break;

      case SAVE_KYC_RESPONSE:
        draft.kycDocsSuccessResponse = true;
        draft.kycResponse = action.data;
        break;

      case SAVE_VENDOR_DETAILS:
        draft.SETTLEMENT_DETAILS = {};
        draft.BANK_DETAILS = {};
        draft.ACCOUNT_DETAILS = {};
        draft.vendorDetailsSuccessResponse = true;
        draft.vendorDetailsById = action.data;
        draft.vendorStatus = action.data.status;

        const {
          accountType: vendorAccountType,
          businessType,
          name,
        } = action.data;

        draft.vendorAccountInfo = {
          accountType: vendorAccountType,
          businessType,
          name,
        };

        ALL_SETTLEMENT_DETIALS.forEach(obj => {
          if (obj === 'amountToBeSettled') {
            draft.SETTLEMENT_DETAILS[obj] = `₹ ${action.data[obj]}`;
          } else {
            draft.SETTLEMENT_DETAILS[obj] = action.data[obj];
          }
        });

        const { schedule } = action.data;

        draft.SETTLEMENT_DETAILS.settlementScheduleMessage =
          schedule.settlementScheduleMessage;

        ALL_ACCOUNT_DETAILS.forEach(obj => {
          if (action.data[obj]) {
            draft.ACCOUNT_DETAILS[obj] = action.data[obj];
          }
        });

        let addStatus = false;

        ALL_BANK_DETAILS.forEach(obj => {
          if (action.data[obj]) {
            draft.BANK_DETAILS[obj] = action.data[obj];
            addStatus = true;
          }
        });

        if (addStatus && action.data?.status)
          draft.BANK_DETAILS.status = action.data.status;

        break;

      case SAVE_VENDOR_KYC_DETAILS:
        draft.kycDetialsSuccessResponse = true;
        draft.KYC_DETAILS = [];

        const { accountType } = action.data;

        if (accountType === 'INDIVIDUAL') {
          ALL_KYC_INDIVIDUAL_DETAILS.forEach(obj => {
            draft.KYC_DETAILS[obj] = action.data[obj];
          });
        } else if (accountType === 'BUSINESS') {
          ALL_KYC_BUSINESS_DETAILS.forEach(obj => {
            draft.KYC_DETAILS[obj] = action.data[obj];
          });
        }
        break;

      case SAVE_SETTLEMENT_CONFIG: {
        draft.schedules = action.data;
        break;
      }

      case SAVE_VENDOR_DOCS: {
        draft.vendorDocs = action.data;
        break;
      }

      case DEFAULT_ACTION:
        break;
    }
  });

export default easySplitDetailsReducer;
